<template>
	<div>
		<vxe-modal v-model="modal_model" :show-zoom="true" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid :loading="loading" ref="modifieddetail" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="上传万里牛" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			row: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_title: '调整明细',
				modal_width:800,
				data:[],
				modal_height:500,
				sourcedata:[],
				list_footerField:[
					{field:'size',toFixed:0},
					{field:'sum',toFixed:2},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init(){
				this.modal_title = '调整明细【'+this.row.billCode+'】'
			},
			sizeChange(e){
				e.row.sum = e.row.size * e.row.price
			},
			priceChange(e){
				let target = this.sourcedata.find((item)=>{
					return item.detailID == e.row.detailID
				})
				if(target){
					e.row.sum = e.row.size * e.row.price
					e.row.discountRate = (e.row.price/target.price * 100).toFixed(2)
				}
			},
			discountRateChange(e){
				let target = this.sourcedata.find((item)=>{
					return item.detailID == e.row.detailID
				})
				if(target){
					e.row.price = target.price * (e.row.discountRate/100)
					e.row.sum = e.row.size * e.row.price
				}
			},
			sumChange(e){
				e.row.price = e.row.sum / e.row.size
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.importConfig = {
					types: ['xls', 'xlsx'],
					remote: true,
					importMethod:this.importMethod
				},
				gridOptions.toolbarConfig.buttons = [
					{
						name: '导出',
						status: 'success',
						code: 'export'
					},
					{
						name: '导入',
						status: 'primary',
						code: 'import'
					}
				]
				gridOptions.columns = [{
						field: 'skuCode',
						title: '商品编码',
						width:100,
					},
					{
						field: 'goodsName',
						title: '商品名称',
						width:100,
					},
					{
						field: 'skuName',
						title: '规格名称',
						width:100,
					},
					{
						field: 'size',
						title: '数量',
						width:100,
						editRender: {
							name: '$inputNumber',
							events: {
								change: (e) => {
									this.sizeChange(e)
								}
							}
						}
						
					},
					{
						field: 'discountRate',
						title: '折扣率',
						width:100,
						editRender: {
							name: '$inputNumber',
							props:{
								step:0.01,
								precision:2
							},
							events: {
								change: (e) => {
									this.discountRateChange(e)
								}
							}
						}
					},
					{
						field: 'price',
						title: '折后单价',
						width:100,
						editRender: {
							name: '$inputNumber',
							props:{
								step:0.001,
								precision:4
							},
							events: {
								change: (e) => {
									this.priceChange(e)
								}
							}
						}
					},
					{
						field: 'sum',
						title: '总价',
						width:100,
						editRender: {
							name: '$inputNumber',
							props:{
								step:0.001,
								precision:4
							},
							events: {
								change: (e) => {
									this.sumChange(e)
								}
							}
						}
					},
					{
						field: 'nazhi_price1',
						title: '往期价格',
						width:100,
					},
					{
						field: 'remark',
						width:100,
						title: '备注',
						fixed:'right',
						editRender: {
							name: '$input',
							props:{

							},
							events: {

							}
						}
					},
					{
						field: 'planArriveDate',
						width:120,
						title: '预计到货日期',
						fixed:'right',
						editRender: {
							name: '$datePicker',
							props:{
								type:'date'
							},
							events: {
					
							}
						}
					},
					
					{
						field: 'nazhi_pricefluctuations',
						title: '价格波动(%)',
						width:100,
						fixed:'right',
					},
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.sourcedata = this.data
					this.data.forEach((item)=>{
						item['planArriveDate'] = item['planArriveDate']? item['planArriveDate']* 1000 : null
					})
					resolve({
						list: JSON.parse(JSON.stringify(this.data))
					})
				})
			},
			submit() {
				let data = this.$refs.modifieddetail.getTableData().fullData
				if(data.length==0){
					this.$message.error('暂无明细数据')
					return
				}
				this.$confirm('是否确认修改','提示').then(()=>{
					this.loading = true
					this.$api.wlnpurchase.modifieddetail({
						billCode:this.row.billCode,
						detail: data
					}).then(() => {
						this.loading = false
						this.modal_cancel()
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				})

			},
			importMethod(e){
				let tabledata = this.$refs.modifieddetail.getTableData().fullData
				let file = e.file
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary'
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet)
					if (jsonData.length != 0) {
						jsonData.forEach((item)=>{
							let row = tabledata.find((_item)=>{
								return _item.skuCode == item['商品编码']
							})
							if(row){							
								row.size = item['数量']
								row.price = item['折后单价']
								row.discountRate = item['折扣率']
								row.sum = item['总价']								
							}
						})
					} else {
						this.$message.error('暂无数据')
					}
				}
				reader.readAsBinaryString(file)
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>